Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.PostView extends Backbone.View
  className: 'post'
  template:  JST['backbone/templates/monitoring/reports/daily_insights/post']

  initialize: (@options = {}) =>
    @sections=[]
    @options.sentimentHeight = 405
    @options.cloudHeight = 265
    @options.cloudPadding = 130
  
  render: ->
    @$el.html(@template({network: @options.section, content_id: @options.post.content_id}))
    @customRender()
    @sections.push(new Monitoring.Reports.DailyInsights.SentimentDistributionView(@options))
    @sections.push(new Monitoring.Reports.DailyInsights.WordsCloudView(@options))

    for section in @sections
      section.render()
      @$('[data-view=' + section.className + ']').append(section.el)